// extracted by mini-css-extract-plugin
export default {"root":"ToggleButton_root__54Li6","toggleWrapper":"ToggleButton_toggleWrapper__BDfYB","activeBtn":"ToggleButton_activeBtn__atndY"};